import euroSportTuningDefault from '../9u0pekimaz-1/config.js';

window.Convermax.isLoggedIn = window.document.querySelector(
  '.navUser .navBar-action[href="/login.php?action=logout"]',
);

function getActiveCurrency() {
  return document.querySelector(`[data-dropdown=currencySelection]`)?.textContent.trim().toLowerCase();
}

function formatPrice(price) {
  if (!price) {
    return '';
  }

  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: getActiveCurrency(),
  }).format(price);
}

export default {
  includes: ['9u0pekimaz-1'],
  ...euroSportTuningDefault,
  product: {
    ...euroSportTuningDefault.product,
    formatPrice,
  },
};
